import React, { Component } from "react"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import Dashboard from "../../components/Dashboard"
import { ENDPOINTS } from "../../constants"
import {
  customNpsHasData,
  keyItemDataHasData,
  employeeCountsHasData,
  arrayValuesHaveData,
  engagementAveragesHasData,
  lAndDCompletedHasData,
  journeysHasData
} from "../../utils/object-utils"
import {
  ReadyToMove,
  EngagementScoreLineChart,
  RiskOfLeavingBar,
  LabourTurnover,
  EngagementScoreDoughnut,
  AgreedLAndDCompleted,
  LeaversInFirst100Days,
  LengthOfServiceAverage,
  CustomNPS,
  Journeys
} from "../../components/widgets"

class EmployeeEngagementDashboard extends Component {
  static propTypes = {
    onReload: PropTypes.func.isRequired
  }

  render() {
    const { t, onReload } = this.props // eslint-disable-line react/prop-types
    const { isLoading, errorMessageKey, widgets, loadingFailed } = this.props.dashboard // eslint-disable-line
    const title = t("Dashboards.Names.EmployeeEngagement")

    return (
      <Dashboard
        errorMessageKey={errorMessageKey}
        isLoading={isLoading}
        loadingFailed={loadingFailed}
        onReload={onReload}
        title={title}
        widgetData={widgets}
      >
        {engagementAveragesHasData(widgets.engagementScoreDoughnut.data) && (
          <EngagementScoreDoughnut
            data={widgets.engagementScoreDoughnut.data}
            appliedFilters={widgets.engagementScoreDoughnut.filters}
            exportEndpoint={ENDPOINTS.Export.EngagementAverageScore}
            subtitleKey={widgets.engagementScoreDoughnut.subtitle}
            sampleSize={widgets.engagementScoreDoughnut.sampleSize}
          />
        )}

        {keyItemDataHasData(widgets.riskOfLeavingBar.data) && (
          <RiskOfLeavingBar
            data={widgets.riskOfLeavingBar.data}
            appliedFilters={widgets.riskOfLeavingBar.filters}
            exportEndpoint={ENDPOINTS.Export.RiskOfLeavingBar}
            subtitleKey={widgets.riskOfLeavingBar.subtitle}
          />
        )}

        {keyItemDataHasData(widgets.engagementScoreLine.data) && (          
          widgets.engagementScoreLine.data.length > 1 && (
            <EngagementScoreLineChart
              data={widgets.engagementScoreLine.data}
              appliedFilters={widgets.engagementScoreLine.filters}
              exportEndpoint={ENDPOINTS.Export.EngagementCombinedAverages}
              subtitleKey={widgets.engagementScoreLine.subtitle}
              sampleSize={widgets.engagementScoreLine.sampleSize}
            />
          )
        )}

        {keyItemDataHasData(widgets.readyToMove.data) && (
          <ReadyToMove
            data={widgets.readyToMove.data}
            appliedFilters={widgets.readyToMove.filters}
            exportEndpoint={ENDPOINTS.Export.ReadyToMoveOn}
            subtitleKey={widgets.readyToMove.subtitle}
            sampleSize={widgets.readyToMove.sampleSize}
          />
        )}

        {customNpsHasData(widgets.employeeNetPromotorScore.data) && (
          <CustomNPS
            data={widgets.employeeNetPromotorScore.data}
            appliedFilters={widgets.employeeNetPromotorScore.filters}
            exportEndpoint={ENDPOINTS.Export.CustomNetPromoter}
            subtitleKey={widgets.employeeNetPromotorScore.subtitle}
            sampleSize={widgets.employeeNetPromotorScore.sampleSize}
          />
        )}

        {arrayValuesHaveData(widgets.labourTurnover.data) && (
          <LabourTurnover
            data={widgets.labourTurnover.data}
            appliedFilters={widgets.labourTurnover.filters}
            exportEndpoint={ENDPOINTS.Export.LabourTurnover}
            subtitleKey={widgets.labourTurnover.subtitle}
            sampleSize={widgets.labourTurnover.sampleSize}
          />
        )}

        {arrayValuesHaveData(widgets.leaversInFirst100Days.data) && (
          <LeaversInFirst100Days
            data={widgets.leaversInFirst100Days.data}
            appliedFilters={widgets.leaversInFirst100Days.filters}
            exportEndpoint={ENDPOINTS.Export.LeaversInFirst100Days}
            subtitleKey={widgets.leaversInFirst100Days.subtitle}
            sampleSize={widgets.leaversInFirst100Days.sampleSize}
          />
        )}

        {employeeCountsHasData(widgets.averageLengthOfService.data) && (
          <LengthOfServiceAverage
            data={widgets.averageLengthOfService.data}
            appliedFilters={widgets.averageLengthOfService.filters}
            exportEndpoint={ENDPOINTS.Export.AverageLengthOfService}
            sampleSize={widgets.averageLengthOfService.sampleSize}
          />
        )}

        {lAndDCompletedHasData(widgets.agreedLAndDCompletion.data) && (
          <AgreedLAndDCompleted
            data={widgets.agreedLAndDCompletion.data}
            appliedFilters={widgets.agreedLAndDCompletion.filters}
            exportEndpoint={ENDPOINTS.Export.LAndDCompleted}
            subtitleKey={widgets.agreedLAndDCompletion.subtitle}
            sampleSize={widgets.agreedLAndDCompletion.sampleSize}
          />
        )}

        {journeysHasData(widgets.journeyResponses.data) && (
          <Journeys
            data={widgets.journeyResponses.data}
            appliedFilters={widgets.journeyResponses.filters}
            exportEndpoint={ENDPOINTS.Export.Journeys}
          />
        )}
      </Dashboard>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.employeeEngagement
  }
}

export default compose(translate(), connect(mapStateToProps))(EmployeeEngagementDashboard)



// WEBPACK FOOTER //
// ./src/routes/dashboards/EmployeeEngagementDashboard.jsx